import styled from 'styled-components';
export const Wrapper = styled.div`
  z-index: 10;
  background-color: ${props => props.color};
  ${props => props.translateX !== undefined ? `transform: translateX(-50%) translateX(${props.translateX}px) !important;` : ''}
  &::before {
    border-color: ${props => props.color};
    border-left: 0.625em solid transparent;
    border-right: 0.625em solid transparent;
    border-bottom-width: 0.625em;
    border-bottom-style: solid;
    ${props => props.arrowLeft !== undefined ? `left: ${props.arrowLeft}px !important;` : ''}
  }
`;